import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import {
	payoutDetatilsSpPopUp,
	spPayoutPayloadModel,
	spPayoutResponseModel,
} from 'src/app/modules/payout/models/sp-payout.models'
import { PaymentPayoutStatus } from '../../models/client-payout.enum'
import { Subscription } from 'rxjs'
import { PayoutDetailsComponent } from '../../pages/payout-details/payout-details.component'
import {
	AcceptRejectPayoutModel,
	payoutDetatilsModel,
} from '../../models/client-payout'
import { MatDialog } from '@angular/material/dialog'
import { PayoutService } from '../../services/payout.service'
import { SpSelectTransactionComponent } from '../sp-select-transaction/sp-select-transaction.component'

@Component({
	selector: 'app-sp-payout-table',
	templateUrl: './sp-payout-table.component.html',
	styleUrls: ['./sp-payout-table.component.scss'],
})
export class SpPayoutTableComponent implements OnInit {
	@Input() listData!: spPayoutResponseModel[]
	@Input() payoutFilter: any = {
		countryId: 224,
		searchText: '',
		activeTab: 1,
	}
	@Input() totalCount = 0
	@Output() refresh = new EventEmitter()
	inCompleteDataHover: boolean = false
	hoverId!: number | null
	PaymentPayoutStatus = PaymentPayoutStatus
	subscription = new Subscription()
	spDetailsData!: payoutDetatilsSpPopUp
	acceptPayoutModel: any = {
		id: 0,
		payoutAmount: 0,
		notes: '',
		attachementUrl: '',
	
	}
	constructor(
		public translate: TranslateService,
		private dialog: MatDialog,
		private payoutService: PayoutService
	) {}

	ngOnInit(): void {}

	openDetails(id: number) {
		this.subscription.add(
			this.payoutService.getServicePayoutDetails(id).subscribe((res: any) => {
				this.spDetailsData = res.result
				this.dialog.open(PayoutDetailsComponent, {
					width: '75%',
					height: '90%',
					disableClose: true,
					data: {
						serviceProvider: true,
						serviceProviderData: this.spDetailsData,
					},
				})
			})
		)
	}

	openSelect(id: number) {
		this.subscription.add(
			this.payoutService.getServicePayoutDetails(id).subscribe((res: any) => {
				this.spDetailsData = res.result
				if (this.spDetailsData.payoutMethod != null) {
					this.dialog
						.open(SpSelectTransactionComponent, {
							width: '75%',
							height: '90%',
							data: {
								serviceProviderData: this.spDetailsData,
							},
						})
						.afterClosed()
						.subscribe({
							next: (res) => {
								if (res) {
									this.acceptPayoutModel.id = this.spDetailsData.id
									this.acceptPayoutModel.attachementUrl = res.image
									this.acceptPayoutModel.notes = res.notes
									this.acceptPayoutModel.payoutAmount =
										this.spDetailsData.requestedAmount
									this.acceptPayoutModel.sPpayoutMethodId = res.sPpayoutMethodId
									this.acceptPayoutModel = {
										...this.acceptPayoutModel,
									}

									this.payoutService
										.acceptSPPendingPayout(this.acceptPayoutModel)
										.subscribe((res: any) => {
											if (res) {
												this.refresh.emit(true)
											}
										})
								}
							},
						})
				}
			})
		)
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe()
	}
}
